'use strict';

module.exports = require('./es6/crcjam').default;



//////////////////
// WEBPACK FOOTER
// ./~/crc/lib/crcjam.js
// module id = 767
// module chunks = 0